var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-wrapper"},[_c('fa',{staticClass:"stat-icon",attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"stat-details"},[_vm._v(_vm._s(_vm.stat.count)+" "+_vm._s(_vm.stat.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }